/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';
import { GetTeam } from './team.get';

const Params = z.strictObject({ organizationId: ZodTypes.Id });

export const PostTeam = {
  id: 'team.post',
  tag: 'Team',
  summary: 'Create organization team',
  description: 'Create a team in an organization',
  method: 'post',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/organization/${params.organizationId}/team`,
  request: {
    params: Params,
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            identifier: ZodTypes.Team.Identifier,
            displayName: ZodTypes.Team.DisplayName,
            about: ZodTypes.Team.About.nullish(),
          }),
        },
      },
    },
  },
  response: { 200: GetTeam.response['200'] },
} as const satisfies Endpoint;
